const counts = [
  { title: "Đang hoạt động", value: "danghoatdong" },
  { title: "Ngày hôm nay", value: "ngayhomnay" },
  { title: "Tháng hiện tại", value: "thanghientai" },
  { title: "Tất cả", value: "tatca" },
];

export default counts;
